<template>
  <div>
    <div class="separator-breadcrumb border-top"></div>
    <div class="row">
      <div class="col-md-12">
        <div class="card mb-4">
          <div class="card-body">
            <div class="card-title mb-3">New defective products sale order</div>
            <fieldset class="border p-3">
              <div>
                <form @submit.prevent="newDeadSale()">
                  <div class="row">
                    <div class="col-md-12">
                      <div class="table-responsive" width="100">
                        <table class="table">
                          <thead>
                            <tr>
                              <th scope="col">#</th>
                              <th scope="col">Product</th>
                              <th scope="col">Truck</th>
                              <th scope="col">Balance Before</th>
                              <th scope="col">Quantity</th>
                              <th scope="col">Balance After</th>
                              <th scope="col">Unit price</th>
                              <th scope="col">Total</th>
                              <th scope="col">Remark</th>
                            </tr>
                          </thead>
                          <tbody>
                            <tr
                              v-for="(sale_product, k) in deadsaleItemsrows"
                              :key="k"
                            >
                              <td scope="row">
                                <button
                                  type="button"
                                  class="btn btn-danger"
                                  @click="deleteRow(k, sale_product)"
                                >
                                  <i class="fa fa-trash"></i>
                                </button>
                                <!-- <i class="fa fa-trash-alt" @click="deleteRow(k, sale_product)"></i> -->
                              </td>
                              <td>
                                <model-list-select
                                  :list="systemDeadStocks"
                                  v-model="sale_product.product_id"
                                  option-value="id"
                                  :custom-text="productNameandNumber"
                                  placeholder="select Product"
                                  @input="
                                    getDeadProduct(sale_product.product_id)
                                  "
                                ></model-list-select>
                              </td>
                              <td>
                                <model-list-select
                                  :list="systemTrucks"
                                  v-model="sale_product.truck_id"
                                  option-value="id"
                                  option-text="truck_no"
                                  placeholder="select truck name"
                                ></model-list-select>
                              </td>
                              <td>
                                <input
                                  readonly
                                  required
                                  class="form-control"
                                  id="balance_stock"
                                  type="number"
                                  v-model="sale_product.balance_stock"
                                />
                              </td>
                              <td>
                                <input
                                  required
                                  class="form-control"
                                  type="number"
                                  min="1"
                                  step=".01"
                                  v-model="sale_product.qty"
                                  @keyup="calculateLineTotal(sale_product)"
                                />
                              </td>
                              <td>
                                <input
                                  readonly
                                  required
                                  class="form-control"
                                  id="balance_stock"
                                  type="number"
                                  v-model="sale_product.product_measurement"
                                />
                              </td>

                              <td>
                                <input
                                  required
                                  class="form-control"
                                  type="number"
                                  min="1"
                                  step=".01"
                                  v-model="sale_product.unit_price"
                                  @keyup="calculateLineTotal(sale_product)"
                                />
                              </td>
                              <td>
                                <input
                                  required
                                  readonly
                                  class="form-control text-right"
                                  type="number"
                                  min="1"
                                  step=".01"
                                  v-model="sale_product.total_price"
                                />
                              </td>
                              <td>
                                <input
                                  class="form-control text-right"
                                  type="text"
                                  v-model="sale_product.remark"
                                />
                              </td>
                            </tr>
                            <tr v-show="deadsaleItemsrows.length === 0">
                              <td colspan="7">
                                <p class="text-center alert-danger p-2">
                                  No products added/available.
                                </p>
                              </td>
                            </tr>
                          </tbody>
                          <tfoot>
                            <tr>
                              <td colspan="7" class="text-right">Sub Total</td>
                              <input
                                readonly
                                class="form-control text-right sub_total"
                                type="number"
                                min="1"
                                step=".01"
                                :value="invoice_subtotal"
                              />
                            </tr>
                            <tr>
                              <td colspan="7" class="text-right">Total</td>
                              <input
                                readonly
                                class="form-control text-right sales_total"
                                type="number"
                                min="1"
                                step=".01"
                                :value="invoice_total"
                              />
                            </tr>
                          </tfoot>
                        </table>
                      </div>
                    </div>
                    <div class="clearfix"></div>
                    <div class="col-md-12 mb-2">
                      <button
                        type="button"
                        class="btn btn-info addRow"
                        @click="addDeadSaleItems"
                      >
                        <i class="fa fa-plus-circle"></i>
                        Add
                      </button>
                    </div>
                    <button
                      type="submit"
                      class="btn btn-primary btn-flat creatingSale btn-rounded"
                    >
                      <i class="fa fa-plus"></i> create sale order
                    </button>
                    <button
                      type="button"
                      class="btn-rounded btn-flat creatingSaleLoader btn-rounded"
                    >
                      <span
                        class="spinner-border spinner-border-sm"
                        role="status"
                        aria-hidden="true"
                      ></span>
                      <i
                        class="fa fa-spinner fa-spin"
                        style="font-size: 24px"
                      ></i>
                      please wait...
                    </button>
                  </div>
                </form>
              </div>
            </fieldset>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import { mapActions, mapGetters, mapMutations } from "vuex";
import router from "../router/index";
import { ModelListSelect } from "vue-search-select";
import Vue from "vue";
export default {
  data() {
    return {
      invoice_subtotal: 0,
      invoice_total: 0,
    };
  },
  created() {
    this.loadProduct();
    this.loadTrucks();
    this.loadDeadStocks();
  },
  computed: {
    ...mapGetters([
      "deadsaleItemsrows",
      "systemTrucks",
      "systemProducts",
      "systemDeadStocks",
      "deadsystemProducts",
      "getProductsprice",
    ]),
  },
  methods: {
    ...mapActions([
      "newDeadSale",
      "loadTrucks",
      "loadProduct",
      "loadDeadStocks",
      "getDeadProduct",
    ]),
    ...mapMutations(["addDeadSaleItems"]),
    productNameandNumber(item) {
      return `${item.product_name} - (${item.product_number})`;
    },
    calculateTotal() {
      var subtotal, total, totals;
      subtotal = this.deadsaleItemsrows.reduce(function (sum, product) {
        var lineTotal = parseFloat(product.total_price);
        if (!isNaN(lineTotal)) {
          return sum + lineTotal;
        }
      }, 0);

      if (!isNaN(subtotal)) {
        this.invoice_subtotal = subtotal.toFixed(2);
      } else {
        this.invoice_subtotal = "0.00";
      }
      total = subtotal;
      total = parseFloat(total);
      if (!isNaN(total)) {
        this.invoice_total = total.toFixed(2);
      } else {
        this.invoice_total = "0.00";
      }
    },
    calculateLineTotal(sale_product) {
      var balance_stock = (sale_product.balance_stock =
        this.$store.getters.deadsystemProducts);

      var total2 =
        parseFloat(sale_product.balance_stock) - parseFloat(sale_product.qty);
      if (!isNaN(total2)) {
        sale_product.product_measurement = total2;
      }
      if (parseFloat(sale_product.qty) > parseFloat(balance_stock)) {
        // var excess_stock = sale_product.qty - balance_stock;
        Vue.swal.fire({
          title: "Stock balance",
          text: "The product quantity is greater than the balance stock! Kindly note you will not be able to add any other row  or submit data untill you sort the requested quantity ",
          type: "warning",
        });
        $(".addRow").attr("disabled", true);
        $(".creatingSale").attr("disabled", true);
      } else {
        $(".addRow").attr("disabled", false);
        $(".creatingSale").attr("disabled", false);
      }
      var total =
        parseFloat(sale_product.unit_price) * parseFloat(sale_product.qty);
      if (!isNaN(total)) {
        sale_product.total_price = total.toFixed(2);
      }

      this.calculateTotal();
    },
    deleteRow(index, sale_product) {
      var idx = this.deadsaleItemsrows.indexOf(sale_product);
      if (idx > -1) {
        this.deadsaleItemsrows.splice(idx, 1);
      }
      $(".addRow").attr("disabled", false);
      $(".creatingSale").attr("disabled", false);
      this.calculateTotal();
    },
  },
  components: {
    ModelListSelect,
  },
};
</script>
<style scoped>
.creatingSaleLoader {
  display: none;
}
</style>


// WEBPACK FOOTER //
// src/deadsales/defectivesale.vue